

const demoFiles = [
{
  id: "demo-file-1",
  name: "Q4_Financial_Report_2025.pdf",
  size: 2456789,
  mimeType: "application/pdf",
  downloadURL: "",
  status: "READY",
  ocrConfidence: 0.95,
  ocrText: "Financial Report Q4 2025\nTotal Revenue: $4,567,890\nNet Income: $1,234,567\nOperating Expenses: $2,345,678",
  classification: "Financial Report",
  tags: ["finance", "quarterly", "2025"],
  folderId: "demo-folder-1",
  userId: "demo-user",
  createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 2 * 60 * 60 * 1000)
},
{
  id: "demo-file-2",
  name: "Employment_Contract_Template.docx",
  size: 1234567,
  mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  downloadURL: "",
  status: "READY",
  ocrConfidence: 0.92,
  ocrText: "Employment Contract\nThis agreement is entered into between...\nPosition: Software Engineer\nSalary: $85,000/year",
  classification: "Legal Document",
  tags: ["hr", "contract", "template"],
  folderId: "demo-folder-2",
  userId: "demo-user",
  createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 24 * 60 * 60 * 1000)
},
{
  id: "demo-file-3",
  name: "Invoice_2025_0042.pdf",
  size: 567890,
  mimeType: "application/pdf",
  downloadURL: "",
  status: "NEED_APPROVAL",
  ocrConfidence: 0.72,
  ocrText: "INVOICE #2025-0042\nBill To: ABC Corporation\nAmount: $12,500.00\nDue Date: February 28, 2025",
  classification: "Invoice",
  tags: ["invoice", "2025", "abc-corp"],
  folderId: "demo-folder-1",
  userId: "demo-user",
  createdAt: new Date(Date.now() - 48 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 48 * 60 * 60 * 1000)
},
{
  id: "demo-file-4",
  name: "Product_Presentation.pptx",
  size: 8901234,
  mimeType: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  downloadURL: "",
  status: "READY",
  ocrConfidence: 0.88,
  ocrText: "Product Launch 2026\nNew Features Overview\nMarket Analysis\nCompetitive Landscape",
  classification: "Presentation",
  tags: ["marketing", "product", "launch"],
  folderId: "demo-folder-3",
  userId: "demo-user",
  createdAt: new Date(Date.now() - 72 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 72 * 60 * 60 * 1000)
},
{
  id: "demo-file-5",
  name: "Meeting_Notes_Board.docx",
  size: 345678,
  mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  downloadURL: "",
  status: "READY",
  ocrConfidence: 0.96,
  ocrText: "Board Meeting Notes - January 2025\nAttendees: CEO, CFO, CTO, COO\nAgenda: 1. Revenue Review 2. Q1 Planning",
  classification: "Meeting Notes",
  tags: ["meeting", "board", "2025"],
  folderId: "demo-folder-2",
  userId: "demo-user",
  createdAt: new Date(Date.now() - 96 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 96 * 60 * 60 * 1000)
},
{
  id: "demo-file-6",
  name: "National_ID_Scan.jpg",
  size: 2345678,
  mimeType: "image/jpeg",
  downloadURL: "",
  status: "QUARANTINED",
  ocrConfidence: 0.85,
  ocrText: "Republic of Turkey Identity Card\nTC No: 12345678901\nName: AHMET YILMAZ",
  classification: "Identity Document",
  tags: ["id", "personal", "sensitive"],
  piiDetected: true,
  folderId: "demo-folder-4",
  userId: "demo-user",
  createdAt: new Date(Date.now() - 120 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 120 * 60 * 60 * 1000)
},
{
  id: "demo-file-7",
  name: "Server_Architecture_Diagram.png",
  size: 4567890,
  mimeType: "image/png",
  downloadURL: "",
  status: "READY",
  ocrConfidence: 0.45,
  ocrText: "Load Balancer → API Gateway → Microservices",
  classification: "Technical Diagram",
  tags: ["architecture", "infrastructure", "technical"],
  folderId: "demo-folder-5",
  userId: "demo-user",
  createdAt: new Date(Date.now() - 168 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 168 * 60 * 60 * 1000)
},
{
  id: "demo-file-8",
  name: "Budget_2026_Forecast.xlsx",
  size: 1567890,
  mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  downloadURL: "",
  status: "PROCESSING",
  ocrConfidence: null,
  ocrText: null,
  classification: null,
  tags: ["budget", "forecast", "2026"],
  folderId: "demo-folder-1",
  userId: "demo-user",
  createdAt: new Date(Date.now() - 30 * 60 * 1000),
  updatedAt: new Date(Date.now() - 30 * 60 * 1000)
}];


const demoFolders = [
{ id: "demo-folder-1", name: "Finance", color: "#5e72e4", userId: "demo-user", fileCount: 3, createdAt: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000) },
{ id: "demo-folder-2", name: "Legal & HR", color: "#2dce89", userId: "demo-user", fileCount: 2, createdAt: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000) },
{ id: "demo-folder-3", name: "Marketing", color: "#fb6340", userId: "demo-user", fileCount: 1, createdAt: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000) },
{ id: "demo-folder-4", name: "Personal", color: "#f5365c", userId: "demo-user", fileCount: 1, createdAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000) },
{ id: "demo-folder-5", name: "Technical", color: "#11cdef", userId: "demo-user", fileCount: 1, createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000) }];


const demoNotifications = [
{ id: "notif-1", type: "share", message: "Sarah shared 'Q4_Financial_Report_2025.pdf' with you", read: false, createdAt: new Date(Date.now() - 5 * 60 * 1000) },
{ id: "notif-2", type: "ocr", message: "OCR completed for 'Invoice_2025_0042.pdf' — Approval required", read: false, createdAt: new Date(Date.now() - 30 * 60 * 1000) },
{ id: "notif-3", type: "quota", message: "You have used 80% of your monthly operation quota", read: false, createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000) },
{ id: "notif-4", type: "security", message: "New login detected from Chrome on macOS", read: true, createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000) },
{ id: "notif-5", type: "system", message: "System maintenance scheduled for Sunday 02:00 UTC", read: true, createdAt: new Date(Date.now() - 48 * 60 * 60 * 1000) },
{ id: "notif-6", type: "upload", message: "'Budget_2026_Forecast.xlsx' is being processed", read: true, createdAt: new Date(Date.now() - 72 * 60 * 60 * 1000) }];


const demoUsage = {
  operations: 7542,
  operationLimit: 10000,
  storageUsed: 12.4,
  storageLimit: 50,
  concurrentUsers: 8,
  concurrentLimit: 20,
  aiTokens: 45230,
  burstCapacity: 500
};

const demoAuditLogs = [
{ id: "audit-1", action: "FILE_UPLOAD", details: { fileName: "Budget_2026_Forecast.xlsx" }, user: "demo@futuredocument.com", createdAt: new Date(Date.now() - 30 * 60 * 1000) },
{ id: "audit-2", action: "FILE_SHARE", details: { fileName: "Q4_Financial_Report_2025.pdf", sharedWith: "sarah@company.com" }, user: "demo@futuredocument.com", createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000) },
{ id: "audit-3", action: "FILE_DOWNLOAD", details: { fileName: "Employment_Contract_Template.docx" }, user: "demo@futuredocument.com", createdAt: new Date(Date.now() - 5 * 60 * 60 * 1000) },
{ id: "audit-4", action: "FOLDER_CREATE", details: { folderName: "Technical" }, user: "demo@futuredocument.com", createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000) },
{ id: "audit-5", action: "OCR_APPROVE", details: { fileName: "Meeting_Notes_Board.docx" }, user: "demo@futuredocument.com", createdAt: new Date(Date.now() - 48 * 60 * 60 * 1000) },
{ id: "audit-6", action: "FILE_DELETE", details: { fileName: "Old_Report_2024.pdf" }, user: "demo@futuredocument.com", createdAt: new Date(Date.now() - 72 * 60 * 60 * 1000) },
{ id: "audit-7", action: "USER_LOGIN", details: { ip: "192.168.1.1", browser: "Chrome 120" }, user: "demo@futuredocument.com", createdAt: new Date(Date.now() - 96 * 60 * 60 * 1000) }];


const demoShares = [
{ id: "share-1", fileId: "demo-file-1", sharedWith: "sarah@company.com", permission: "edit", createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000) },
{ id: "share-2", fileId: "demo-file-1", sharedWith: "john@company.com", permission: "view", createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000) },
{ id: "share-3", fileId: "demo-file-2", sharedWith: "hr@company.com", permission: "download", expiresAt: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), createdAt: new Date(Date.now() - 48 * 60 * 60 * 1000) },
{ id: "share-4", fileId: "demo-file-5", sharedWith: "ceo@company.com", permission: "view", createdAt: new Date(Date.now() - 72 * 60 * 60 * 1000) }];


const demoVersions = [
{ id: "ver-3", fileId: "demo-file-1", versionNum: 3, size: 2456789, changedBy: "demo@futuredocument.com", displayName: "Demo User", changeNote: "Revenue figures updated", downloadURL: "", createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000) },
{ id: "ver-2", fileId: "demo-file-1", versionNum: 2, size: 2345678, changedBy: "demo@futuredocument.com", displayName: "Demo User", changeNote: "Q4 analysis added", downloadURL: "", createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000) },
{ id: "ver-1", fileId: "demo-file-1", versionNum: 1, size: 2123456, changedBy: "demo@futuredocument.com", displayName: "Demo User", changeNote: "Initial upload", downloadURL: "", createdAt: new Date(Date.now() - 72 * 60 * 60 * 1000) },
{ id: "ver-6", fileId: "demo-file-6", versionNum: 3, size: 2445000, changedBy: "demo@futuredocument.com", displayName: "Demo User", changeNote: "High-resolution scan", downloadURL: "", createdAt: new Date(Date.now() - 4 * 60 * 60 * 1000) },
{ id: "ver-5", fileId: "demo-file-6", versionNum: 2, size: 2380000, changedBy: "admin@futuredocument.com", displayName: "Admin", changeNote: "Crop and rotate", downloadURL: "", createdAt: new Date(Date.now() - 48 * 60 * 60 * 1000) },
{ id: "ver-4", fileId: "demo-file-6", versionNum: 1, size: 2345678, changedBy: "demo@futuredocument.com", displayName: "Demo User", changeNote: "Initial upload", downloadURL: "", createdAt: new Date(Date.now() - 120 * 60 * 60 * 1000) }];



export function getDemoFiles() {return [...demoFiles];}
export function getDemoFolders() {return [...demoFolders];}
export function getDemoNotifications() {return [...demoNotifications];}
export function getDemoUsage() {return { ...demoUsage };}
export function getDemoAuditLogs() {return [...demoAuditLogs];}
export function getDemoShares(fileId) {
  if (fileId) return demoShares.filter((s) => s.fileId === fileId);
  return [...demoShares];
}
export function getDemoVersions(fileId) {
  if (fileId) return demoVersions.filter((v) => v.fileId === fileId);
  return [...demoVersions];
}
export function getDemoFileById(fileId) {
  return demoFiles.find((f) => f.id === fileId) || null;
}


export function formatFileSize(bytes) {
  if (!bytes) return "0 B";
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
}

export function getFileIcon(mimeType) {
  if (!mimeType) return "ni ni-single-copy-04";
  if (mimeType.includes("pdf")) return "ni ni-single-copy-04 text-danger";
  if (mimeType.includes("word") || mimeType.includes("document")) return "ni ni-single-copy-04 text-primary";
  if (mimeType.includes("sheet") || mimeType.includes("excel")) return "ni ni-chart-bar-32 text-success";
  if (mimeType.includes("presentation") || mimeType.includes("powerpoint")) return "ni ni-tv-2 text-warning";
  if (mimeType.includes("image")) return "ni ni-image text-info";
  return "ni ni-single-copy-04 text-default";
}

export function getStatusBadge(status) {
  const map = {
    READY: { color: "success", label: "Ready" },
    PROCESSING: { color: "info", label: "Processing" },
    NEED_APPROVAL: { color: "warning", label: "Needs Approval" },
    QUARANTINED: { color: "danger", label: "Quarantined" },
    SCANNING: { color: "info", label: "Scanning" }
  };
  return map[status] || { color: "secondary", label: status };
}

export function timeAgo(date) {
  if (!date) return "";
  const d = date instanceof Date ? date : date.toDate ? date.toDate() : new Date(date);
  const diff = Date.now() - d.getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} hours ago`;
  const days = Math.floor(hours / 24);
  return `${days} days ago`;
}




const demoInvoices = [
{
  id: "inv-1",
  invoiceNo: "FTR-2026-001",
  type: "e-fatura",
  vendor: "Future Tech Works",
  customer: "ABC Corporation",
  items: [
  { description: "Cloud Storage License (Annual)", quantity: 1, unitPrice: 24000, taxRate: 20 },
  { description: "Setup & Configuration", quantity: 5, unitPrice: 800, taxRate: 20 }],

  amount: 28000,
  currency: "TRY",
  taxRate: 20,
  taxAmount: 5600,
  totalAmount: 33600,
  status: "paid",
  dueDate: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
  paidDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
  pdfURL: "",
  xmlURL: "",
  relatedFileIds: ["demo-file-3"],
  relatedStockEntryIds: [],
  createdBy: "demo-user",
  createdAt: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000)
},
{
  id: "inv-2",
  invoiceNo: "FTR-2026-002",
  type: "e-arsiv",
  vendor: "Future Tech Works",
  customer: "XYZ Industries Ltd.",
  items: [
  { description: "Document Processing API (1000 calls)", quantity: 3, unitPrice: 5000, taxRate: 20 }],

  amount: 15000,
  currency: "TRY",
  taxRate: 20,
  taxAmount: 3000,
  totalAmount: 18000,
  status: "pending",
  dueDate: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000),
  paidDate: null,
  pdfURL: "",
  xmlURL: "",
  relatedFileIds: [],
  relatedStockEntryIds: [],
  createdBy: "demo-user",
  createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
},
{
  id: "inv-3",
  invoiceNo: "FTR-2026-003",
  type: "manual",
  vendor: "Global Consulting Group",
  customer: "Future Tech Works",
  items: [
  { description: "IT Consulting (hours)", quantity: 40, unitPrice: 1200, taxRate: 20 },
  { description: "Security Audit Report", quantity: 1, unitPrice: 15000, taxRate: 20 }],

  amount: 63000,
  currency: "TRY",
  taxRate: 20,
  taxAmount: 12600,
  totalAmount: 75600,
  status: "approved",
  dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
  paidDate: null,
  pdfURL: "",
  xmlURL: "",
  relatedFileIds: ["demo-file-1"],
  relatedStockEntryIds: [],
  createdBy: "demo-user",
  createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000)
},
{
  id: "inv-4",
  invoiceNo: "FTR-2026-004",
  type: "e-fatura",
  vendor: "Future Tech Works",
  customer: "DEF Holding Inc.",
  items: [
  { description: "Enterprise License (50 users)", quantity: 1, unitPrice: 120000, taxRate: 20 }],

  amount: 120000,
  currency: "TRY",
  taxRate: 20,
  taxAmount: 24000,
  totalAmount: 144000,
  status: "draft",
  dueDate: new Date(Date.now() + 45 * 24 * 60 * 60 * 1000),
  paidDate: null,
  pdfURL: "",
  xmlURL: "",
  relatedFileIds: [],
  relatedStockEntryIds: [],
  createdBy: "demo-user",
  createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000)
},
{
  id: "inv-5",
  invoiceNo: "FTR-2026-005",
  type: "e-fatura",
  vendor: "Office Supplies Co.",
  customer: "Future Tech Works",
  items: [
  { description: "Printer Paper A4 (box)", quantity: 20, unitPrice: 250, taxRate: 10 },
  { description: "Toner Cartridge", quantity: 4, unitPrice: 1500, taxRate: 10 }],

  amount: 11000,
  currency: "TRY",
  taxRate: 10,
  taxAmount: 1100,
  totalAmount: 12100,
  status: "cancelled",
  dueDate: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000),
  paidDate: null,
  pdfURL: "",
  xmlURL: "",
  relatedFileIds: [],
  relatedStockEntryIds: [],
  createdBy: "demo-user",
  createdAt: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 40 * 24 * 60 * 60 * 1000)
}];


export function getDemoInvoices() {
  return demoInvoices;
}

export function getDemoInvoiceById(id) {
  return demoInvoices.find((inv) => inv.id === id) || null;
}

export function getInvoiceStatusBadge(status) {
  const map = {
    draft: { color: "secondary", label: "Draft" },
    pending: { color: "warning", label: "Pending" },
    approved: { color: "info", label: "Approved" },
    paid: { color: "success", label: "Paid" },
    cancelled: { color: "danger", label: "Cancelled" }
  };
  return map[status] || { color: "secondary", label: status };
}

export function getInvoiceTypeBadge(type) {
  const map = {
    "e-fatura": { color: "primary", label: "E-Fatura" },
    "e-arsiv": { color: "info", label: "E-Archive" },
    "manual": { color: "default", label: "Manuel" }
  };
  return map[type] || { color: "secondary", label: type };
}




const demoAccounts = [
{
  id: "acc-1",
  name: "ABC Corporation",
  type: "customer",
  taxId: "1234567890",
  email: "info@abccorp.com",
  phone: "+90 212 555 1234",
  address: "Istanbul, Levent, Buyukdere Ave. No:185",
  balance: 33600,
  currency: "TRY",
  contractFileIds: ["demo-file-2"],
  paymentPlanIds: [
  { date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), amount: 10000, paid: true },
  { date: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000), amount: 12000, paid: false },
  { date: new Date(Date.now() + 45 * 24 * 60 * 60 * 1000), amount: 11600, paid: false }],

  tags: ["enterprise", "premium"],
  createdBy: "demo-user",
  workspaceId: "ws-1",
  createdAt: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000)
},
{
  id: "acc-2",
  name: "XYZ Industries Ltd.",
  type: "customer",
  taxId: "9876543210",
  email: "muhasebe@xyz-ind.com",
  phone: "+90 216 444 5678",
  address: "Istanbul, Kadikoy, Bagdat Ave. No:42",
  balance: 18000,
  currency: "TRY",
  contractFileIds: [],
  paymentPlanIds: [],
  tags: ["startup"],
  createdBy: "demo-user",
  workspaceId: "ws-1",
  createdAt: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000)
},
{
  id: "acc-3",
  name: "Global Consulting Group",
  type: "vendor",
  taxId: "5556667788",
  email: "billing@globalconsulting.com",
  phone: "+90 312 333 9999",
  address: "Ankara, Cankaya, Kizilay Mah. No:10",
  balance: -75600,
  currency: "TRY",
  contractFileIds: ["demo-file-1"],
  paymentPlanIds: [
  { date: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000), amount: 25000, paid: false },
  { date: new Date(Date.now() + 40 * 24 * 60 * 60 * 1000), amount: 25000, paid: false },
  { date: new Date(Date.now() + 70 * 24 * 60 * 60 * 1000), amount: 25600, paid: false }],

  tags: ["consulting", "IT"],
  createdBy: "demo-user",
  workspaceId: "ws-1",
  createdAt: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000)
},
{
  id: "acc-4",
  name: "DEF Holding Inc.",
  type: "customer",
  taxId: "1112223334",
  email: "finans@defholding.com.tr",
  phone: "+90 232 777 4455",
  address: "Izmir, Alsancak, Kordon Cad. No:88",
  balance: 0,
  currency: "TRY",
  contractFileIds: [],
  paymentPlanIds: [],
  tags: ["holding"],
  createdBy: "demo-user",
  workspaceId: "ws-1",
  createdAt: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000)
},
{
  id: "acc-5",
  name: "Office Supplies Co.",
  type: "vendor",
  taxId: "4445556667",
  email: "siparis@officesupplies.com",
  phone: "+90 212 888 1122",
  address: "Istanbul, Sisli, Halaskargazi Cad. No:120",
  balance: -12100,
  currency: "TRY",
  contractFileIds: [],
  paymentPlanIds: [],
  tags: ["supplier", "office"],
  createdBy: "demo-user",
  workspaceId: "ws-1",
  createdAt: new Date(Date.now() - 100 * 24 * 60 * 60 * 1000)
}];


const demoTransactions = [

{ id: "tx-1", accountId: "acc-1", type: "debit", amount: 33600, description: "Invoice FTR-2026-001 - Cloud Storage License", invoiceId: "inv-1", date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), createdBy: "demo-user", createdAt: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000) },
{ id: "tx-2", accountId: "acc-1", type: "credit", amount: 10000, description: "Payment - Bank transfer (1st installment)", invoiceId: null, date: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000), createdBy: "demo-user", createdAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000) },
{ id: "tx-3", accountId: "acc-1", type: "credit", amount: 10000, description: "Payment - EFT transfer", invoiceId: null, date: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), createdBy: "demo-user", createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000) },



{ id: "tx-4", accountId: "acc-2", type: "debit", amount: 18000, description: "Invoice FTR-2026-002 - API Processing", invoiceId: "inv-2", date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), createdBy: "demo-user", createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000) },


{ id: "tx-5", accountId: "acc-3", type: "credit", amount: 75600, description: "Invoice FTR-2026-003 - IT Consulting + Security Audit", invoiceId: "inv-3", date: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000), createdBy: "demo-user", createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000) },


{ id: "tx-6", accountId: "acc-5", type: "credit", amount: 12100, description: "Invoice FTR-2026-005 - Office Supplies", invoiceId: "inv-5", date: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000), createdBy: "demo-user", createdAt: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000) }];


export function getDemoAccounts() {
  return [...demoAccounts];
}

export function getDemoAccountById(id) {
  return demoAccounts.find((a) => a.id === id) || null;
}

export function getDemoTransactions(accountId) {
  if (accountId) return demoTransactions.filter((tx) => tx.accountId === accountId);
  return [...demoTransactions];
}

export function getAccountTypeBadge(type) {
  const map = {
    customer: { color: "success", label: "Customer" },
    vendor: { color: "warning", label: "Vendor" }
  };
  return map[type] || { color: "secondary", label: type };
}


const demoApprovalRequests = [
{
  id: "apr-1",
  type: "expense",
  title: "New server purchase (Dell PowerEdge R750)",
  description: "New server purchase under the IT infrastructure renewal project.",
  amount: 185000,
  currency: "TRY",
  requestedBy: "demo-user",
  requestedByName: "Demo User",
  currentApproverId: "user-director-1",
  approvalChain: [
  { userId: "user-manager-1", displayName: "Ahmet Kaya (Manager)", role: "manager", label: "Manager", status: "approved", note: "Approved as appropriate.", timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000) },
  { userId: "user-director-1", displayName: "Elif Demir (Director)", role: "director", label: "Director", status: "pending", note: "", timestamp: null },
  { userId: "user-cfo-1", displayName: "Mehmet Oz (CFO)", role: "cfo", label: "CFO", status: "pending", note: "", timestamp: null }],

  status: "in_review",
  relatedInvoiceId: null,
  relatedFileIds: [],
  createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000)
},
{
  id: "apr-2",
  type: "payment",
  title: "ABC Corporation payment - 2nd installment",
  description: "Cloud Storage License invoice 2nd installment payment.",
  amount: 10000,
  currency: "TRY",
  requestedBy: "demo-user",
  requestedByName: "Demo User",
  currentApproverId: "user-manager-1",
  approvalChain: [
  { userId: "user-manager-1", displayName: "Ahmet Kaya (Manager)", role: "manager", label: "Manager", status: "pending", note: "", timestamp: null },
  { userId: "user-director-1", displayName: "Elif Demir (Director)", role: "director", label: "Director", status: "pending", note: "", timestamp: null }],

  status: "pending",
  relatedInvoiceId: "inv-1",
  relatedFileIds: [],
  createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000)
},
{
  id: "apr-3",
  type: "invoice",
  title: "Annual software license renewal",
  description: "Microsoft 365 E5 license renewal - 50 users.",
  amount: 4500,
  currency: "USD",
  requestedBy: "demo-user",
  requestedByName: "Demo User",
  currentApproverId: null,
  approvalChain: [
  { userId: "user-manager-1", displayName: "Ahmet Kaya (Manager)", role: "manager", label: "Manager", status: "approved", note: "Urgent need, approved.", timestamp: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000) },
  { userId: "user-director-1", displayName: "Elif Demir (Director)", role: "director", label: "Director", status: "approved", note: "", timestamp: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000) },
  { userId: "user-cfo-1", displayName: "Mehmet Oz (CFO)", role: "cfo", label: "CFO", status: "approved", note: "Within budget, approved.", timestamp: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000) }],

  status: "approved",
  relatedInvoiceId: null,
  relatedFileIds: [],
  createdAt: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000)
},
{
  id: "apr-4",
  type: "expense",
  title: "Office furniture replacement",
  description: "2nd floor open office furniture replacement.",
  amount: 750,
  currency: "TRY",
  requestedBy: "demo-user",
  requestedByName: "Demo User",
  currentApproverId: null,
  approvalChain: [
  { userId: "user-manager-1", displayName: "Ahmet Kaya (Manager)", role: "manager", label: "Manager", status: "rejected", note: "No budget this period, should be postponed.", timestamp: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000) }],

  status: "rejected",
  relatedInvoiceId: null,
  relatedFileIds: [],
  createdAt: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000)
},
{
  id: "apr-5",
  type: "expense",
  title: "Stationery supplies",
  description: "Monthly office stationery needs.",
  amount: 480,
  currency: "TRY",
  requestedBy: "demo-user",
  requestedByName: "Demo User",
  currentApproverId: null,
  approvalChain: [
  { userId: "user-manager-1", displayName: "Ahmet Kaya (Manager)", role: "manager", label: "Manager", status: "approved", note: "", timestamp: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000) }],

  status: "approved",
  relatedInvoiceId: "inv-5",
  relatedFileIds: [],
  createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000)
}];


export function getDemoApprovals() {
  return [...demoApprovalRequests];
}

export function getDemoApprovalById(id) {
  return demoApprovalRequests.find((a) => a.id === id) || null;
}

export function getApprovalStatusBadge(status) {
  const map = {
    pending: { color: "warning", label: "Pending" },
    in_review: { color: "info", label: "In Review" },
    approved: { color: "success", label: "Approved" },
    rejected: { color: "danger", label: "Rejected" }
  };
  return map[status] || { color: "secondary", label: status };
}

export function getApprovalTypeBadge(type) {
  const map = {
    expense: { color: "primary", label: "Expense" },
    payment: { color: "info", label: "Payment" },
    invoice: { color: "warning", label: "Invoice" },
    license_renewal: { color: "success", label: "License Renewal" }
  };
  return map[type] || { color: "secondary", label: type };
}




const demoProducts = [
{
  id: "prd-1",
  sku: "PRD-EL-001",
  barcode: "8690001000011",
  name: "Dell PowerEdge R750 Server",
  category: "electronics",
  description: "2U rack server, 2x Intel Xeon Gold 5318Y, 256 GB RAM, 4x 1.92 TB NVMe SSD. Procured for the IT infrastructure project.",
  unit: "adet",
  currentStock: 3,
  minStockLevel: 2,
  maxStockLevel: 10,
  costPrice: 185000,
  salePrice: 210000,
  currency: "TRY",
  imageURLs: [],
  technicalDocIds: ["doc-srv-spec-01"],
  certificateIds: ["cert-ce-001"],
  serialTracking: true,
  lotTracking: false,
  tags: ["server", "datacenter", "dell"],
  workspaceId: "ws-1",
  createdBy: "demo-user",
  createdAt: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000)
},
{
  id: "prd-2",
  sku: "PRD-OF-002",
  barcode: "8690001000028",
  name: "A4 Copy Paper (5000 sheets)",
  category: "office",
  description: "80 gsm A4 paper, 10 packs x 500 sheets.",
  unit: "adet",
  currentStock: 48,
  minStockLevel: 20,
  maxStockLevel: 200,
  costPrice: 320,
  salePrice: 420,
  currency: "TRY",
  imageURLs: [],
  technicalDocIds: [],
  certificateIds: [],
  serialTracking: false,
  lotTracking: true,
  tags: ["stationery", "paper"],
  workspaceId: "ws-1",
  createdBy: "demo-user",
  createdAt: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000)
},
{
  id: "prd-3",
  sku: "PRD-RM-003",
  barcode: "8690001000035",
  name: "Stainless Steel Sheet (2mm)",
  category: "raw_material",
  description: "AISI 304 grade, 1000x2000 mm, 2 mm thickness.",
  unit: "adet",
  currentStock: 12,
  minStockLevel: 5,
  maxStockLevel: 50,
  costPrice: 4800,
  salePrice: 5900,
  currency: "TRY",
  imageURLs: [],
  technicalDocIds: ["doc-material-spec-03"],
  certificateIds: ["cert-iso-9001", "cert-tsek-304"],
  serialTracking: false,
  lotTracking: true,
  tags: ["steel", "raw-material", "sheet"],
  workspaceId: "ws-1",
  createdBy: "demo-user",
  createdAt: new Date(Date.now() - 120 * 24 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000)
},
{
  id: "prd-4",
  sku: "PRD-SP-004",
  barcode: "8690001000042",
  name: "Hydraulic Pump Filter",
  category: "spare_parts",
  description: "Parker TXW series, 10 micron, for industrial hydraulic systems.",
  unit: "adet",
  currentStock: 1,
  minStockLevel: 5,
  maxStockLevel: 30,
  costPrice: 1250,
  salePrice: 1650,
  currency: "TRY",
  imageURLs: [],
  technicalDocIds: ["doc-filter-spec-04"],
  certificateIds: [],
  serialTracking: true,
  lotTracking: false,
  tags: ["filter", "hydraulic", "spare-part"],
  workspaceId: "ws-1",
  createdBy: "demo-user",
  createdAt: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000)
},
{
  id: "prd-5",
  sku: "PRD-PK-005",
  barcode: "8690001000059",
  name: "Bubble Wrap (50m)",
  category: "packaging",
  description: "50 cm width, 50 meter roll, standard bubble wrap.",
  unit: "adet",
  currentStock: 35,
  minStockLevel: 10,
  maxStockLevel: 100,
  costPrice: 180,
  salePrice: 250,
  currency: "TRY",
  imageURLs: [],
  technicalDocIds: [],
  certificateIds: [],
  serialTracking: false,
  lotTracking: false,
  tags: ["packaging", "packing"],
  workspaceId: "ws-1",
  createdBy: "demo-user",
  createdAt: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
},
{
  id: "prd-6",
  sku: "PRD-CN-006",
  barcode: "8690001000066",
  name: "Industrial Cleaning Liquid (5L)",
  category: "consumables",
  description: "Multi-purpose industrial cleaner, 5-liter canister.",
  unit: "lt",
  currentStock: 60,
  minStockLevel: 20,
  maxStockLevel: 200,
  costPrice: 95,
  salePrice: 140,
  currency: "TRY",
  imageURLs: [],
  technicalDocIds: [],
  certificateIds: ["cert-msds-006"],
  serialTracking: false,
  lotTracking: true,
  tags: ["cleaning", "consumable"],
  workspaceId: "ws-1",
  createdBy: "demo-user",
  createdAt: new Date(Date.now() - 75 * 24 * 60 * 60 * 1000),
  updatedAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000)
}];


const demoStockMovements = [

{ id: "mv-1", productId: "prd-1", type: "in", quantity: 5, previousStock: 0, newStock: 5, unitCost: 185000, reason: "Initial purchase - PO-2025-112", note: "Initial purchase - PO-2025-112", sourceWarehouse: "", destWarehouse: "Main Warehouse", relatedInvoiceId: "inv-3", shipmentDocIds: ["ship-1"], serialNumbers: ["SRV-001", "SRV-002", "SRV-003", "SRV-004", "SRV-005"], lotNumber: "", performedBy: "demo-user", createdBy: "demo-user", createdAt: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000) },
{ id: "mv-2", productId: "prd-1", type: "out", quantity: 2, previousStock: 5, newStock: 3, unitCost: 185000, reason: "Project allocation - IT-Dept", note: "Project allocation - IT-Dept", sourceWarehouse: "Main Warehouse", destWarehouse: "", relatedInvoiceId: null, shipmentDocIds: ["ship-2"], serialNumbers: ["SRV-004", "SRV-005"], lotNumber: "", performedBy: "demo-user", createdBy: "demo-user", createdAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000) },

{ id: "mv-3", productId: "prd-2", type: "in", quantity: 100, previousStock: 0, newStock: 100, unitCost: 320, reason: "Bulk purchase", note: "Bulk purchase", sourceWarehouse: "", destWarehouse: "Main Warehouse", relatedInvoiceId: "inv-5", shipmentDocIds: ["ship-3"], serialNumbers: [], lotNumber: "LOT-KGT-2025-01", performedBy: "demo-user", createdBy: "demo-user", createdAt: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000) },
{ id: "mv-4", productId: "prd-2", type: "out", quantity: 52, previousStock: 100, newStock: 48, unitCost: 320, reason: "Monthly consumption", note: "Monthly consumption", sourceWarehouse: "Main Warehouse", destWarehouse: "", relatedInvoiceId: null, shipmentDocIds: [], serialNumbers: [], lotNumber: "", performedBy: "demo-user", createdBy: "demo-user", createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000) },

{ id: "mv-5", productId: "prd-4", type: "in", quantity: 10, previousStock: 0, newStock: 10, unitCost: 1250, reason: "Initial stock entry", note: "Initial stock entry", sourceWarehouse: "", destWarehouse: "Spare Parts Warehouse", relatedInvoiceId: null, shipmentDocIds: [], serialNumbers: ["FLT-001", "FLT-002", "FLT-003", "FLT-004", "FLT-005", "FLT-006", "FLT-007", "FLT-008", "FLT-009", "FLT-010"], lotNumber: "", performedBy: "demo-user", createdBy: "demo-user", createdAt: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000) },
{ id: "mv-6", productId: "prd-4", type: "out", quantity: 9, previousStock: 10, newStock: 1, unitCost: 1250, reason: "Maintenance program usage", note: "Maintenance program usage", sourceWarehouse: "Spare Parts Warehouse", destWarehouse: "", relatedInvoiceId: null, shipmentDocIds: [], serialNumbers: ["FLT-002", "FLT-003", "FLT-004", "FLT-005", "FLT-006", "FLT-007", "FLT-008", "FLT-009", "FLT-010"], lotNumber: "", performedBy: "demo-user", createdBy: "demo-user", createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000) },

{ id: "mv-7", productId: "prd-5", type: "transfer", quantity: 10, previousStock: 35, newStock: 35, unitCost: 180, reason: "Inter-warehouse transfer", note: "Inter-warehouse transfer", sourceWarehouse: "Main Warehouse", destWarehouse: "Branch Warehouse", relatedInvoiceId: null, shipmentDocIds: ["ship-4"], serialNumbers: [], lotNumber: "", performedBy: "demo-user", createdBy: "demo-user", createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000) },
{ id: "mv-8", productId: "prd-6", type: "adjustment", quantity: 60, previousStock: 55, newStock: 60, unitCost: 95, reason: "Stock count adjustment", note: "Year-end stock count: +5 difference", sourceWarehouse: "", destWarehouse: "Main Warehouse", relatedInvoiceId: null, shipmentDocIds: [], serialNumbers: [], lotNumber: "LOT-TMZ-2025-Q4", performedBy: "demo-user", createdBy: "demo-user", createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000) }];



const demoShipmentDocs = [
{ id: "ship-1", type: "waybill", documentNo: "IRS-2025-001", vendor: "Dell Technologies", fileURL: "", relatedMovementIds: ["mv-1"], date: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000), createdBy: "demo-user", createdAt: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000) },
{ id: "ship-2", type: "deliveryNote", documentNo: "TSL-2025-042", vendor: "ABC Corporation", fileURL: "", relatedMovementIds: ["mv-2"], date: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000), createdBy: "demo-user", createdAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000) },
{ id: "ship-3", type: "packingList", documentNo: "PL-2025-018", vendor: "Office Supplies Co.", fileURL: "", relatedMovementIds: ["mv-3"], date: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000), createdBy: "demo-user", createdAt: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000) },
{ id: "ship-4", type: "waybill", documentNo: "IRS-2025-088", vendor: "", fileURL: "", relatedMovementIds: ["mv-7"], date: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000), createdBy: "demo-user", createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000) }];


export function getDemoProducts() {
  return [...demoProducts];
}

export function getDemoProductById(id) {
  return demoProducts.find((p) => p.id === id) || null;
}

export function getDemoStockMovements(productId) {
  if (productId) return demoStockMovements.filter((m) => m.productId === productId);
  return [...demoStockMovements];
}

export function getCategoryBadge(category) {
  const map = {
    electronics: { color: "info", label: "Electronics" },
    office: { color: "primary", label: "Office Supplies" },
    furniture: { color: "default", label: "Furniture" },
    raw_material: { color: "warning", label: "Raw Material" },
    packaging: { color: "light", label: "Packaging" },
    spare_parts: { color: "danger", label: "Spare Parts" },
    consumables: { color: "success", label: "Consumables" },
    other: { color: "secondary", label: "Other" }
  };
  return map[category] || { color: "secondary", label: category };
}

export function getUnitLabel(unit) {
  const map = { adet: "Unit", kg: "kg", lt: "lt", m: "m" };
  return map[unit] || unit;
}

export function getMovementTypeBadge(type) {
  const map = {
    in: { color: "success", label: "Inbound" },
    out: { color: "danger", label: "Outbound" },
    transfer: { color: "info", label: "Transfer" },
    adjustment: { color: "warning", label: "Adjustment" }
  };
  return map[type] || { color: "secondary", label: type };
}

export function getDemoAllStockMovements() {
  return [...demoStockMovements];
}

export function getDemoShipmentDocs() {
  return [...demoShipmentDocs];
}

export function getDemoShipmentDocById(id) {
  return demoShipmentDocs.find((d) => d.id === id) || null;
}

export function getShipmentTypeBadge(type) {
  const map = {
    waybill: { color: "info", label: "Waybill" },
    packingList: { color: "success", label: "Packing List" },
    deliveryNote: { color: "warning", label: "Delivery Note" }
  };
  return map[type] || { color: "secondary", label: type };
}




const demoPurchaseRequests = [
{
  id: "pr-1",
  productId: "prd-4",
  productName: "Hydraulic Pump Filter",
  sku: "PRD-SP-004",
  currentStock: 1,
  minStockLevel: 5,
  suggestedQuantity: 29,
  preferredVendorId: null,
  status: "auto_generated",
  unit: "adet",
  estimatedUnitCost: 1250,
  createdBy: "demo-user",
  createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000)
},
{
  id: "pr-2",
  productId: "prd-1",
  productName: "Dell PowerEdge R750 Server",
  sku: "PRD-EL-001",
  currentStock: 3,
  minStockLevel: 2,
  suggestedQuantity: 7,
  preferredVendorId: null,
  status: "submitted",
  unit: "adet",
  estimatedUnitCost: 185000,
  createdBy: "demo-user",
  createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000)
},
{
  id: "pr-3",
  productId: "prd-2",
  productName: "A4 Copy Paper (5000 sheets)",
  sku: "PRD-OF-002",
  currentStock: 48,
  minStockLevel: 20,
  suggestedQuantity: 152,
  preferredVendorId: null,
  status: "ordered",
  unit: "adet",
  estimatedUnitCost: 320,
  createdBy: "demo-user",
  createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000)
},
{
  id: "pr-4",
  productId: "prd-6",
  productName: "Industrial Cleaning Liquid (5L)",
  sku: "PRD-CN-006",
  currentStock: 60,
  minStockLevel: 20,
  suggestedQuantity: 140,
  preferredVendorId: null,
  status: "received",
  unit: "lt",
  estimatedUnitCost: 95,
  receivedQuantity: 140,
  receivedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
  createdBy: "demo-user",
  createdAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000)
}];


export function getDemoPurchaseRequests() {
  return [...demoPurchaseRequests];
}

export function getDemoPurchaseRequestById(id) {
  return demoPurchaseRequests.find((r) => r.id === id) || null;
}

export function getPurchaseRequestStatusBadge(status) {
  const map = {
    auto_generated: { color: "warning", label: "Auto-generated" },
    submitted: { color: "info", label: "Submitted" },
    ordered: { color: "primary", label: "Ordered" },
    received: { color: "success", label: "Received" },
    cancelled: { color: "danger", label: "Cancelled" }
  };
  return map[status] || { color: "secondary", label: status };
}




export function getDemoCriticalProducts() {
  return demoProducts.filter(
    (p) => typeof p.currentStock === "number" && typeof p.minStockLevel === "number" && p.currentStock < p.minStockLevel
  );
}


const demoSerialNumbers = [

{
  id: "sn-1",
  productId: "prd-1",
  serialNo: "BSH-2025-001547",
  status: "in_stock",
  purchaseDate: new Date("2025-01-10"),
  warrantyExpiry: new Date("2027-01-10"),
  customerId: null,
  movementHistory: [
  { date: new Date("2025-01-10"), type: "created", note: "Recorded on purchase" }],

  relatedFileIds: ["doc-1"],
  createdAt: new Date("2025-01-10")
},
{
  id: "sn-2",
  productId: "prd-1",
  serialNo: "BSH-2025-001548",
  status: "sold",
  purchaseDate: new Date("2025-01-10"),
  warrantyExpiry: new Date("2027-01-10"),
  customerId: "Mehmet Construction Inc.",
  movementHistory: [
  { date: new Date("2025-01-10"), type: "created", note: "Recorded on purchase" },
  { date: new Date("2025-03-15"), type: "sold", note: "Sold to Mehmet Construction Inc." }],

  relatedFileIds: [],
  createdAt: new Date("2025-01-10")
},
{
  id: "sn-3",
  productId: "prd-1",
  serialNo: "BSH-2025-001549",
  status: "warranty",
  purchaseDate: new Date("2025-01-10"),
  warrantyExpiry: new Date("2027-01-10"),
  customerId: "Ahmet Construction Ltd.",
  movementHistory: [
  { date: new Date("2025-01-10"), type: "created", note: "Recorded on purchase" },
  { date: new Date("2025-02-20"), type: "sold", note: "Sale completed" },
  { date: new Date("2025-04-05"), type: "warranty", note: "Returned under warranty - motor failure" }],

  relatedFileIds: ["doc-1"],
  createdAt: new Date("2025-01-10")
},
{
  id: "sn-4",
  productId: "prd-1",
  serialNo: "BSH-2024-009210",
  status: "returned",
  purchaseDate: new Date("2024-06-20"),
  warrantyExpiry: new Date("2025-03-20"),
  customerId: "Kaya Engineering",
  movementHistory: [
  { date: new Date("2024-06-20"), type: "created", note: "Initial record" },
  { date: new Date("2024-08-10"), type: "sold", note: "Sale" },
  { date: new Date("2025-01-15"), type: "returned", note: "Customer return request" }],

  relatedFileIds: [],
  createdAt: new Date("2024-06-20")
},
{
  id: "sn-5",
  productId: "prd-1",
  serialNo: "BSH-2023-005100",
  status: "scrapped",
  purchaseDate: new Date("2023-03-15"),
  warrantyExpiry: new Date("2025-03-15"),
  customerId: null,
  movementHistory: [
  { date: new Date("2023-03-15"), type: "created", note: "Initial record" },
  { date: new Date("2024-12-01"), type: "scrapped", note: "Reached end of economic life" }],

  relatedFileIds: [],
  createdAt: new Date("2023-03-15")
},

{
  id: "sn-6",
  productId: "prd-4",
  serialNo: "MKT-2025-003201",
  status: "in_stock",
  purchaseDate: new Date("2025-02-01"),
  warrantyExpiry: new Date("2027-02-01"),
  customerId: null,
  movementHistory: [
  { date: new Date("2025-02-01"), type: "created", note: "Purchase" }],

  relatedFileIds: [],
  createdAt: new Date("2025-02-01")
},
{
  id: "sn-7",
  productId: "prd-4",
  serialNo: "MKT-2025-003202",
  status: "sold",
  purchaseDate: new Date("2025-02-01"),
  warrantyExpiry: new Date("2027-02-01"),
  customerId: "Ali Elektrik Tic.",
  movementHistory: [
  { date: new Date("2025-02-01"), type: "created", note: "Purchase" },
  { date: new Date("2025-04-10"), type: "sold", note: "Sale" }],

  relatedFileIds: [],
  createdAt: new Date("2025-02-01")
}];


export function getDemoSerialNumbers(productId) {
  if (productId) return demoSerialNumbers.filter((s) => s.productId === productId);
  return [...demoSerialNumbers];
}

export function getDemoSerialById(id) {
  return demoSerialNumbers.find((s) => s.id === id) || null;
}

export function getSerialStatusBadge(status) {
  const map = {
    in_stock: { color: "success", label: "Stokta" },
    sold: { color: "info", label: "Sold" },
    warranty: { color: "warning", label: "Garanti" },
    returned: { color: "danger", label: "Returned" },
    scrapped: { color: "dark", label: "Hurda" }
  };
  return map[status] || { color: "secondary", label: status };
}


const demoLots = [

{
  id: "lot-1",
  productId: "prd-2",
  lotNumber: "LOT-2025-HLT-001",
  quantity: 120,
  manufacturingDate: new Date("2025-01-05"),
  expiryDate: new Date("2027-01-05"),
  supplierName: "Hilti Turkey",
  qualityCertFileId: "cert-1",
  status: "active",
  createdAt: new Date("2025-01-15")
},
{
  id: "lot-2",
  productId: "prd-2",
  lotNumber: "LOT-2024-HLT-009",
  quantity: 40,
  manufacturingDate: new Date("2024-06-10"),
  expiryDate: new Date("2025-06-10"),
  supplierName: "Hilti Turkey",
  qualityCertFileId: null,
  status: "active",
  createdAt: new Date("2024-06-20")
},

{
  id: "lot-3",
  productId: "prd-3",
  lotNumber: "LOT-2025-3M-010",
  quantity: 200,
  manufacturingDate: new Date("2025-02-01"),
  expiryDate: new Date("2026-02-01"),
  supplierName: "3M Turkey Distributor",
  qualityCertFileId: "cert-2",
  status: "active",
  createdAt: new Date("2025-02-10")
},
{
  id: "lot-4",
  productId: "prd-3",
  lotNumber: "LOT-2024-3M-003",
  quantity: 15,
  manufacturingDate: new Date("2024-01-15"),

  expiryDate: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000),
  supplierName: "3M Turkey Distributor",
  qualityCertFileId: null,
  status: "active",
  createdAt: new Date("2024-01-20")
},

{
  id: "lot-5",
  productId: "prd-6",
  lotNumber: "LOT-2025-SCH-005",
  quantity: 50,
  manufacturingDate: new Date("2025-03-01"),
  expiryDate: new Date("2028-03-01"),
  supplierName: "Schneider Electric",
  qualityCertFileId: "cert-3",
  status: "active",
  createdAt: new Date("2025-03-10")
},
{
  id: "lot-6",
  productId: "prd-6",
  lotNumber: "LOT-2024-SCH-012",
  quantity: 10,
  manufacturingDate: new Date("2024-04-01"),

  expiryDate: new Date(Date.now() + 20 * 24 * 60 * 60 * 1000),
  supplierName: "Schneider Electric",
  qualityCertFileId: null,
  status: "active",
  createdAt: new Date("2024-04-10")
},
{
  id: "lot-7",
  productId: "prd-6",
  lotNumber: "LOT-2023-SCH-001",
  quantity: 0,
  manufacturingDate: new Date("2023-01-01"),
  expiryDate: new Date("2024-01-01"),
  supplierName: "Schneider Electric",
  qualityCertFileId: null,
  status: "expired",
  createdAt: new Date("2023-01-15")
}];


export function getDemoLots(productId) {
  if (productId) return demoLots.filter((l) => l.productId === productId);
  return [...demoLots];
}

export function getDemoLotById(id) {
  return demoLots.find((l) => l.id === id) || null;
}

export function getLotStatusBadge(status) {
  const map = {
    active: { color: "success", label: "Aktif" },
    expired: { color: "danger", label: "Expired" },
    recalled: { color: "warning", label: "Recalled" }
  };
  return map[status] || { color: "secondary", label: status };
}
